const vocabData = {
  halloween: [
    { content: "witch", matchid: "witch" },
    { content: "https://upload.wikimedia.org/wikipedia/commons/8/8c/Creative-Tail-Halloween-witch.svg", matchid: "witch" },
    { content: "pumpkin", matchid: "pumpkin" },
    { content: "https://upload.wikimedia.org/wikipedia/commons/f/f3/Creative-Tail-Halloween-pumpkin.svg", matchid: "pumpkin" },
    { content: "monster", matchid: "monster" },
    { content: "https://upload.wikimedia.org/wikipedia/commons/3/34/Creative-Tail-Halloween-monster.svg", matchid: "monster" },
    { content: "skull", matchid: "skull" },
    { content: "https://upload.wikimedia.org/wikipedia/commons/c/cb/Creative-Tail-Halloween-skull.svg", matchid: "skull" },
    { content: "ghost", matchid: "ghost" },
    { content: "https://upload.wikimedia.org/wikipedia/commons/c/c4/Creative-Tail-Halloween-ghost.svg", matchid: "ghost" },
    // { content: "bat", matchid: "bat" },
    // { content: "https://upload.wikimedia.org/wikipedia/commons/4/4b/Creative-Tail-Halloween-bat.svg", matchid: "bat" },
    { content: "zombie", matchid: "zombie" },
    { content: "https://upload.wikimedia.org/wikipedia/commons/d/db/Creative-Tail-Halloween-zombie-1.svg", matchid: "zombie" },
    { content: "grave", matchid: "grave" },
    { content: "https://upload.wikimedia.org/wikipedia/commons/0/0e/Creative-Tail-Halloween-grave.svg", matchid: "grave" },
    { content: "candy", matchid: "candy" },
    { content: "https://upload.wikimedia.org/wikipedia/commons/7/75/Creative-Tail-Halloween-candy.svg", matchid: "candy" },
    // { content: "moon", matchid: "moon" },
    // { content: "https://upload.wikimedia.org/wikipedia/commons/7/77/Creative-Tail-Halloween-full-moon.svg", matchid: "moon" },
    { content: "owl", matchid: "owl" },
    { content: "https://upload.wikimedia.org/wikipedia/commons/6/62/Creative-Tail-Halloween-owl.svg", matchid: "owl" },
    // { content: "spider", matchid: "spider" },
    // { content: "https://upload.wikimedia.org/wikipedia/commons/7/73/Creative-Tail-Halloween-spider.svg", matchid: "spider" },
    { content: "cat", matchid: "cat" },
    { content: "https://upload.wikimedia.org/wikipedia/commons/7/75/Creative-Tail-Halloween-black-cat.svg", matchid: "cat" },
  ]
};

export default vocabData;